import axios from 'axios';

import env from '../env.js';

export const API_URL = `${env.API_URL}/`;

const successHandler = (response) => {
    return response
};

const errorHandler = (error) => {
  return Promise.reject(error);
};


const api = (security = true) => {

    let configs = {
        baseURL: API_URL,
        headers: { "Content-Type": "application/json" }
    };

    if (security) {
        configs.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        configs.headers['token'] = localStorage.getItem('token');
    }

    let axiosInstance = axios.create(configs);

    axiosInstance.interceptors.response.use(
        response => successHandler(response),
        error => errorHandler(error)
    )

    return axiosInstance;
}

export default api;